import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_APP_AIRDROPHOST,
    // Add other configurations if needed
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('bearerToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;
